import { render } from "./TripStats.vue?vue&type=template&id=dc71980e"
import script from "./TripStats.vue?vue&type=script&lang=js"
export * from "./TripStats.vue?vue&type=script&lang=js"

import exportComponent from "D:\\PROJET WEB\\carpoolear\\carpoolear_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__